import { memo } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

type Props = {
  isShow: boolean;
  className: string;
  onClick: () => void;
};

export const VisibilityButton = memo(({ className, isShow, onClick }: Props) => {
  return isShow ? (
    <VisibilityOffIcon className={className} onClick={onClick} />
  ) : (
    <VisibilityIcon className={className} onClick={onClick} />
  );
});
VisibilityButton.displayName = 'VisibilityButton';
